(function (root) {
  'use strict';

  function savingsPercent(product) {
    const price = Number(product?.priceInfo?.price);
    const originalPrice = Number(product?.priceInfo?.originalPrice);

    return Number.isFinite(price) &&
      Number.isFinite(originalPrice) &&
      originalPrice > price &&
      price >= 0
      ? Math.round(((originalPrice - price) / originalPrice) * 100)
      : 0;
  }

  if (typeof module !== 'undefined' && module.exports) {
    module.exports = savingsPercent;

    if (require.main === module) {
      require('node:assert/strict').equal(
        savingsPercent({ priceInfo: { price: 75, originalPrice: 100 } }),
        25,
      );
    }
  }

  if (
    !root.customElements ||
    !root.HTMLElement ||
    root.customElements.get('rcc-product-badges')
  ) {
    return;
  }

  class RCCProductBadges extends root.HTMLElement {
    set product(value) {
      this._product = value;
      this.render();
    }

    get product() {
      return this._product;
    }

    connectedCallback() {
      this.render();
    }

    render() {
      const percent = savingsPercent(this._product);
      this.replaceChildren();
      this.hidden = percent === 0;

      if (!percent) return;

      const badge = document.createElement('span');
      badge.className = 'badge badge--on-sale';
      badge.textContent = `Save ${percent}%`;
      this.append(badge);
    }
  }

  root.customElements.define('rcc-product-badges', RCCProductBadges);
})(typeof window !== 'undefined' ? window : globalThis);
